
import InfoView from '../main/info';
import EnterAuthView from '../main/info/enter-auth';
import UserAuthView from '../main/info/user-auth';
import GroupAuthView from '../main/info/group-auth';

import UserServiceView from '../main/myservice';
import ServiceAddView from '../main/myservice/add';
import UserDemandView from '../main/demand/';
import DemandAddView from '../main/demand/add';

import OrderView from '../main/order';
import NewsView from '../main/news';
import ServiceManage from '../main/manage';

// 配置路由
export const router = [
    {
        label: '个人信息',
        key: 'info',
        mode: <InfoView />
    },
    {
        label: '实名认证',
        key: 'info/userauth',
        mode: <UserAuthView />
    },
    {
        label: '企业认证',
        key: 'info/enterauth',
        mode: <EnterAuthView />
    },
    {
        label: '组织认证',
        key: 'info/groupauth',
        mode: <GroupAuthView />
    },
    {
        label: '我的订单',
        key: 'order',
        mode: <OrderView />
    },
    {
        label: '我的消息',
        key: 'news',
        mode: <NewsView />
    },
    {
        label: '资质管理',
        key: 'manage',
        mode: <ServiceManage />
    },
    // {
    //     label: '服务管理',
    //     key: 'service',
    //     mode: <UserServiceView />
    // },
    // {
    //     label: '服务管理',
    //     key: 'service/add/:id',
    //     mode: <ServiceAddView />
    // },
    // {
    //     label: '需求管理',
    //     key: 'demand',
    //     mode: <UserDemandView />
    // },
    // {
    //     label: '需求管理',
    //     key: 'demand/add/:id',
    //     mode: <DemandAddView />
    // },
]

// 配置菜单导航
export const menu = [
    {
        label: '个人信息',
        key: '/usercenter/info',
    },
    {
        label: '我的订单',
        key: '/usercenter/order',
    },
    {
        label: '我的消息',
        key: '/usercenter/news',
    },
    {
        label: '资质管理',
        key: '/usercenter/manage',
    },
    // {
    //     label: '服务管理',
    //     key: '/usercenter/service',
    // },
    // {
    //     label: '需求管理',
    //     key: '/usercenter/demand',
    // },
    // {
    //     label: '违规处理',
    //     key: '/usercenter/violation',
    // },
]
